import { createElement } from "react";
import React from "react";
import { createObj } from "./fable_modules/fable-library-js.4.17.0/Util.js";
import { Signup } from "./Signup.js";
import { Summary } from "./Summary.js";
import { Highlights } from "./Highlights.js";
import { Interop_reactApi } from "./fable_modules/Feliz.2.7.0/Interop.fs.js";
import { singleton, ofArray } from "./fable_modules/fable-library-js.4.17.0/List.js";
import { Interop_reactApi as Interop_reactApi_1 } from "./fable_modules/Feliz.2.7.0/Interop.fs.js";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { createRoot } from "react-dom/client";

export function Landing() {
    let elems_2, elems_1, elems;
    const props_4 = [["clientId", "768029527019-r3c69btl1u386u0d709ahcl830e4v67k.apps.googleusercontent.com"], ["children", singleton(createElement("div", createObj(ofArray([["style", {}], (elems_2 = [createElement(Signup, null), createElement(Summary, null), createElement(Highlights, null), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 50 + "vh",
    }], (elems_1 = [createElement("span", createObj(ofArray([["style", {
        fontSize: 1.5 + "rem",
        textAlign: "center",
        margin: 10,
    }], (elems = ["Hva venter du på? ", createElement("a", {
        style: {
            textDecorationLine: "underline",
        },
        href: "/register",
        children: "Registrer deg på aksje.io!",
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])]))))]];
    return Interop_reactApi_1.createElement(GoogleOAuthProvider, createObj(props_4));
}

export const root = createRoot(document.getElementById("aksjeio-app"));

root.render(createElement(Landing, null));

